import React from 'react';
import { ICONS } from 'Components/utils/icon/icons';
import { t } from 'Src/i18n';
import { classnames } from 'Utils/classnames/classnames.utils';
import { Icon } from 'Components/frameworks/icon/Icon';
type Props = {
  className?: string;
};
export const ExclusiveCollectionBadge = ({ className }: Props) => (
  <span
    className={classnames(
      'text-initial inline-flex shrink-0 items-center gap-5 text-12 font-bold leading-1 text-ultramarine',
      className,
    )}
  >
    <span className="inline-flex aspect-square size-[1.65em] items-center justify-center rounded-full bg-ultramarine leading-0 text-white sm:size-[2em]">
      <Icon name={ICONS.DIAMOND} width="0.85em" />
    </span>
    {t('common.product.exclusiveCollectionTag')}
  </span>
);
